import { useFlags, useLDClient } from "launchdarkly-react-client-sdk";

// Lightweight wrapper to centralize feature flag consumption patterns.
// Extend here with typed helpers (e.g., ensuring expected flag names) as needed.
export function useFeatureFlags() {
	const flags = useFlags();
	const ldClient = useLDClient();

	return { flags, ldClient };
}

// Example typed accessor helper (commented for future reference):
// export function useSingleInvoiceFlag() {
//   const { flags } = useFeatureFlags();
//   return flags?.traxltlSingleInvoice === true;
// }
